// IE 2026 09 28 / ODOO-342342: «Бизнес-кейсы» — «Open in demo» / «Start path» / шаг пути, «Back to the case», «Restore my filters»; вызовы методов
// widget_USE_CASE (контракт v1 §6). Модуль без внешних импортов: store, роутер, DOM и диалоги приходят параметрами (юнит: tests/unit/guidePlay.test.mjs).
//
// Показ (guidePlay_start → play_plan бэка → guidePlay_run):
//   - status бэка: ok — выполняем plan; not_available — «Not available for your role» (текст бэка), перехода нет; soon — Planned / Idea: полоса
//     показывает карточку «скоро», перехода нет; no_anchor — показать нечего; error / нет ответа — уведомление, перехода нет;
//   - switch_process_model — ПМ якоря не текущая: спросить (confirm), да — переключить (store.clientTest_switchPm), нет — остаться;
//   - шаги plan.steps по порядку (только безопасные — контракт): goto_page (роутер, как clientTest_gotoPage), set_chips (чипсы якоря в ПАМЯТИ стола,
//     в запись стола не пишем — правило 13), open_widget (виджет страницы — активировать, иначе открыть по id, без «client test»), open_record (форма
//     записи), wait (не дольше 10 с), presenter_only (текст «только ведущий» в полосе, не выполняется). plan.steps пуст — те же шаги из plan
//     (workspace / page / chips / target);
//   - «мои» чипсы стола сохраняются ДО первой замены (по разу на стол, пока их не вернули) — в памяти и в localStorage (guideChipsBackup:<польз.>:<база>:<стол>),
//     «Restore my filters» (полоса, форма кейса, window.guideCases.restore()) возвращает их: строки стола, applySelector, снимок chipsKeep;
//   - чипсы якоря на страницу, которая ещё не открывалась (fe.guide.chipsOnOpen, по умолчанию вкл.): ставятся при её открытии — store.guideChips_pending
//     забирает mainStore.workspace_show_widgets (guidePlay_applyPending): поверх настоящих строк стола (мои уже подняты снимком chipsKeep), до открытия
//     виджетов, дальше как у фильтров ссылки — applySelector и только потом виджеты: страница грузится один раз, ответы открытия не приносят данные
//     с прежними чипсами, период и прочие строки стола на месте. Страница уже открыта / флаг выключен — после перехода в памяти + applySelector (как шаг
//     set_chips клиентского прогона);
//   - откуда пришли (стол, страница, виджет формы кейса) — для «Back to the case».
//   - IE 2026 09 30 / ODOO-343435: guided-тур (флаг fe.guide.tour, по умолчанию вкл.): действия тура после плана якоря — highlight (рамка + подсказка
//     у виджета / ячейки / чипса), open_cell_passport (guest — подсветка ячейки и «кликните»; auto — синтетический клик, паспорт — метод чтения),
//     open_tab (вкладка виджета), tour_note (текст + картинка; так в S идёт шаг симуляции), cta (кнопка в полосе: страница демо или https-ссылка).
//     Цель не нашлась — текст шага в полосе без подсветки, показ не прерывается. Подсветки снимаются на следующем шаге, ✕ и новом показе.
//     Режим тура (path.tour бэка, marks = false) — место в пути (set_position) не пишется. Флаг выключен — новые действия пропускаются, как у
//     прежнего фронта (бэк их и не пришлёт: client.use_cases_tour не объявлен).
import { guideCases_on, guideCases_tourOn, guideCases_flag, guideCases_count, guideCases_addMs, guideCases_now, UC_SEGMENT, FLAG_CHIPS_OPEN } from './guideCases.js'   // IE 2026 09 30 / ODOO-343435: + guideCases_tourOn
import { guidePath_fromPlan, guidePath_index, guidePath_next, guidePath_prev } from './guidePath.js'
import { guideChecks_begin, guideChecks_eval } from './guideChecks.js'
import { guideRoute_items, guideRoute_el } from './guideRoute.js'   // demo-webscm 2026 11 02 / ODOO-350612: маршрут показа навигатора — номера кликов   // demo-webscm 2026 11 02 / ODOO-350612: предикаты wait_for
import { guideTarget_resolve, guideTarget_mark, guideTarget_clearMarks, guideTarget_click, guideTarget_openTab, guideTarget_findWidget, guideTarget_openPassport, guideTarget_tagBtn, guideTarget_onlyByButton, guideTarget_uiEl } from './guideTarget.js'   // IE 2026 09 30 / ODOO-343435   // IE 2026 10 13 / ODOO-343435

const isObj = (x) => !!(x && typeof x === 'object')
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const clone = (x) => JSON.parse(JSON.stringify(x === undefined ? null : x))
const identityT = (text, params) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (params && k in params) ? String(params[k]) : m)
const defaultSleep = (ms) => new Promise(res => setTimeout(res, ms))

// ======================================================================= транспорт: методы widget_USE_CASE
// Запрос — как у метода формы (контракт §6): executeWidgetMethod, WIDGET.widget_class widget_USE_CASE, record {id, segment} (бэк перечитывает запись
// по id; doc / _doc / view не везём). Виджет-носитель — суррогат на активном столе (как у workspace_applySelector стора), чтобы метод можно было
// звать и из полосы, когда формы кейса нет: без спиннера формы, без отмены параллельных запросов (no_del_last_backend_action), ответ — в промисе.
export function guideApi_vueObj(store, recordId) {
    const ws = store?.activeWORKSPACE?.workspace || Object.keys(store?.WORKSPACES || {})[0] || ''
    const WIDGET = { id: -342342, widget: 'widget-record', widget_class: 'widget_USE_CASE', workspace: ws, title: '', notification: {},
        record: { id: str(recordId), segment: UC_SEGMENT } }
    return { WIDGET, content_Changed() {}, set_commandPanel() {} }
}
export function guideApi_send(store, method, params = {}, opts = {}) {
    return new Promise((resolve) => {
        let done = false, timer = null
        const fin = (a) => { if (!done) { done = true; if (timer) clearTimeout(timer); resolve(a || null) } }
        const recordId = str(opts.recordId || params.id || params.path || '')
        const vueObj = guideApi_vueObj(store, recordId)
        if (!vueObj.WIDGET.workspace || !store || typeof store.executeWidgetMethod !== 'function') { fin(null); return }
        try {
            store.executeWidgetMethod(vueObj, {
                command: 'executeWidgetMethod', method, params,
                record: { id: recordId, segment: UC_SEGMENT },
                widget_sendToBackend_exclude: ['view'],
                no_del_last_backend_action: true,
                ...(opts.quiet ? { quiet_errors: true } : {}),   // IE 2026 09 28 / ODOO-342342 (Н1): личные отметки — без тостов ошибки (mainStore.executeWidgetMethod)
                _response_callback: (answer) => fin(answer),
                _onResponse: (answer) => { if (answer === null) fin(null) },
            })
        } catch (e) { fin(null) }
        if (!done) timer = setTimeout(() => fin(null), opts.timeoutMs || 60000)
    })
}

// ======================================================================= чипсы
export function guideChips_lv(row) {
    if (!isObj(row)) return ''
    const lv = row.leftValue
    return isObj(lv) ? str(lv.value) : str(lv)
}
// служебная строка стола (её считает бэк: hidden / calc* / rel_*) — не «мой» фильтр и не трогается показом
export function guideChips_isService(row) {
    const k = guideChips_lv(row)
    return !isObj(row) || row.hidden === true || k.startsWith('calc') || k.startsWith('rel_')
}
// «мои» строки стола — копия (для сохранения / возврата)
export function guideChips_userRows(WHERE) {
    return clone((Array.isArray(WHERE) ? WHERE : []).filter(r => isObj(r) && !guideChips_isService(r)))
}
// строки, которые показ не трогает, если их нет среди чипсов якоря: чипс периода и глобальный чипс метрик (у них своя логика по умолчанию)
const keepRow = (r) => !!(r && (r.period || r.chip_segment === 'CHIP-Metric'))

// Чипсы якоря (TEST-DATA doc.chips: [{binding, title, condition, values: [{value, valueStr, relation_segment?}]}]) → новые строки WHERE стола.
// Как processing_tests.apply_chips_to_workspace_params бэка (прогон тестов): строка с тем же binding — use: true, attrs = значения (rightValue
// опустошается — значения только в attrs, как у новой строки бэка); нет строки — новая AttrChipWhere (widget — из определения стола, если есть).
// «Мои» строки, которых нет среди чипсов якоря, — выключаются (use: false): вид воспроизводит контекст якоря, где их не было; служебные, период и
// метрики — как есть. Возвращает { WHERE, set, created, cleared } — исходный массив не меняется
export function guideChips_apply(WHERE, chips, defs = null) {
    const rows = clone(Array.isArray(WHERE) ? WHERE : [])
    const list = (Array.isArray(chips) ? chips : []).filter(c => isObj(c) && str(c.binding))
    const byBinding = new Map(list.map(c => [str(c.binding), c]))
    const set = [], created = [], cleared = []
    const valueRow = (v, c, tmpl) => ({ use: true, rightValue: {
        attr_type: (isObj(tmpl) && tmpl.attr_type) || 'AttrLink', component: (isObj(tmpl) && tmpl.component) || 'AttrLink',
        relation_segment: str(v.relation_segment || c.relation_segment || (isObj(tmpl) ? tmpl.relation_segment : '') || ''),
        value: v.value, valueStr: str(v.valueStr || v.value) } })
    for (const r of rows) {
        if (!isObj(r) || guideChips_isService(r)) continue
        const k = guideChips_lv(r)
        const c = byBinding.get(k)
        if (c) {
            const values = (Array.isArray(c.values) ? c.values : []).filter(v => isObj(v) && v.value !== undefined && v.value !== null && v.value !== '')
            r.use = values.length > 0
            if (c.condition) r.condition = c.condition
            const tmpl = isObj(r.rightValue) ? r.rightValue : null
            r.attrs = values.map(v => valueRow(v, c, tmpl))
            if (isObj(r.rightValue)) r.rightValue = { ...r.rightValue, value: '', valueStr: '' }
            set.push(k)
            byBinding.delete(k)
        } else if (r.use !== false && !keepRow(r)) {
            r.use = false
            cleared.push(k)
        }
    }
    for (const [k, c] of byBinding) {
        const values = (Array.isArray(c.values) ? c.values : []).filter(v => isObj(v) && v.value !== undefined && v.value !== null && v.value !== '')
        const def = (Array.isArray(defs) ? defs : rows).find(x => isObj(x) && x.widget && guideChips_lv(x) === k)
        const row = { use: values.length > 0, attr_type: 'AttrChipWhere', condition: c.condition || 'in',
            leftValue: { value: k, valueStr: str(c.title || k), attr_type: 'AttrLink', component: 'AttrLink', relation_segment: '' },
            rightValue: { value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', relation_segment: str(c.relation_segment || '') },
            attrs: values.map(v => valueRow(v, c, null)) }
        if (def) row.widget = def.widget
        rows.push(row)
        created.push(k)
        set.push(k)
    }
    return { WHERE: rows, set, created, cleared }
}

// ======================================================================= «мои» фильтры: сохранить до показа, вернуть
export function guideBackup_key(store, ws) {
    const u = store?.user?.id || store?.user?.email || 'user', db = store?.user?.database?.dbid || ''
    return `guideChipsBackup:${u}:${db}:${ws}`
}
const lsGet = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null') } catch (e) { return null } }
const lsSet = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)) } catch (e) { /* хранилище недоступно — копия живёт в памяти */ } }
const lsDel = (k) => { try { localStorage.removeItem(k) } catch (e) { /* no-op */ } }
const lsKeys = (prefix) => { const out = []; try { for (let i = 0; i < localStorage.length; i++) { const k = localStorage.key(i); if (k && k.startsWith(prefix)) out.push(k) } } catch (e) { /* нет хранилища */ } return out }

function backups(store) {
    if (!isObj(store.guideBackups)) store.guideBackups = {}
    return store.guideBackups
}
// столы с несохранёнными «моими» фильтрами (память + localStorage: копия переживает перезагрузку вкладки)
export function guideBackup_list(store) {
    const set = new Set(Object.keys(backups(store)))
    const prefix = guideBackup_key(store, '')
    for (const k of lsKeys(prefix)) set.add(k.slice(prefix.length))
    return [...set].filter(Boolean)
}
export function guideBackup_get(store, ws) {
    return backups(store)[ws] || lsGet(guideBackup_key(store, ws)) || null
}
// сохранить «мои» фильтры стола — только если копии ещё нет (иначе повторный показ сохранил бы чипсы прошлого показа, а не мои). entry: { rows: [...] } —
// «мои» строки стола в момент перед заменой (стол открыт: строки из памяти; открывается показом: строки, поднятые снимком chipsKeep, или умолчания стола)
export function guideBackup_save(store, ws, entry) {
    if (!ws || !isObj(entry)) return false
    if (guideBackup_get(store, ws)) return false
    const e = { ...clone(entry), ws, t: Date.now(), lang: store?.user?.language || '' }
    backups(store)[ws] = e
    lsSet(guideBackup_key(store, ws), e)
    guideCases_count('chipsBackups')
    return true
}
function backup_drop(store, ws) {
    delete backups(store)[ws]
    lsDel(guideBackup_key(store, ws))
}
// «Restore my filters»: ws — один стол, без него — все. Стол открыт — строки на место (служебные — свежие), applySelector (если открыт на странице),
// снимок chipsKeep перезаписывается моими строками; стол в этой вкладке не открыт (копия пережила перезагрузку) — пишется только снимок chipsKeep
// (он и поднимется при открытии). Возвращает число возвращённых столов
export function guideBackup_restore(store, ws = null) {
    const list = ws ? [ws] : guideBackup_list(store)
    let n = 0
    for (const w of list) {
        const e = guideBackup_get(store, w)
        if (!e) continue
        backup_drop(store, w)   // IE 2026 09 28 / ODOO-342342 (ревью З4): до applySelector — иначе снимок chipsKeep «держит» копия (guidePlay_chipsKeepHeld)
        const W = store?.WORKSPACES?.[w]
        const params = W?.record?.doc?.params
        const rows = Array.isArray(e.rows) ? e.rows : null
        if (params && rows) {
            const service = (params.WHERE || []).filter(r => isObj(r) && guideChips_isService(r))
            params.WHERE = [...guideChips_userRows(rows), ...service]
            delete params.calc_selectors_mark
            try { store.update_CHIPS_from_WHERE?.(params) } catch (e2) { /* no-op */ }
            try { if (W.active_page && W.PAGES?.[W.active_page]) store.workspace_applySelector(w, W.active_page) } catch (e2) { console.warn('guide: restore applySelector', e2) }
            try { store.chipsKeep_save?.(W) } catch (e2) { /* снимок best effort */ }
        } else if (rows) {
            try { localStorage.setItem(store.chipsKeep_key(w), JSON.stringify({ t: Date.now(), lang: e.lang || '', WHERE: guideChips_userRows(rows) })) } catch (e2) { /* снимок best effort */ }
        }
        n++
    }
    if (n) guideCases_count('chipsRestored')
    if (n && isObj(store.guideSession)) store.guideSession.restoredAt = Date.now()
    return n
}

// IE 2026 09 28 / ODOO-342342 (ревью З4): снимок chipsKeep (store.chipsKeep_save — его пишет каждый workspace_applySelector) не пишется, пока показ
// держит чипсы стола: полоса показа на экране и у стола есть копия «моих» фильтров (показ их заменил). Иначе чипсы показа попадали в снимок и после
// перезагрузки стол открывался с ними, а полосы уже не было. Снимок остаётся прежним — «мои» строки до показа; ✕ полосы снимает удержание
// (следующее применение чипсов пишет снимок как обычно), «Restore my filters» снимает копию до применения — снимок получает «мои» строки
export function guidePlay_chipsKeepHeld(store, ws) {
    if (!ws || !isObj(store?.guideSession) || !guideCases_on(store)) return false
    if (!guideBackup_get(store, ws)) return false
    guideCases_count('chipsKeepHeld')
    return true
}

// ======================================================================= сессия показа (store.guideSession — полоса пути GuideBar)
function session(store) { return isObj(store.guideSession) ? store.guideSession : null }
function setSession(store, patch) {
    const cur = session(store) || { seq: 0 }
    store.guideSession = { ...cur, ...patch }
    return store.guideSession
}
// IE 2026 09 28 / ODOO-342342 (ревью З3): номер показа. Новый показ и ✕ полосы (guidePlay_end) делают идущий показ недействительным: после каждого
// await он сверяет свой номер и молча выходит — без перехода, чипсов, цели и без новой полосы (setSession пересоздал бы закрытую сессию)
function runNew(store) { store.guideRunId = (Number(store.guideRunId) || 0) + 1; return store.guideRunId }
function runAlive(store, run) { return run == null || store.guideRunId === run }
function runCancelled() { guideCases_count('cancelled'); return { ok: false, status: 'cancelled' } }
// IE 2026 09 30 / ODOO-343435: DOM-часть тура (подсветка, цели) — из utils/guideTarget.js; тест подменяет её ctx.tourApi
const TOUR_API = { resolve: guideTarget_resolve, uiEl: guideTarget_uiEl, mark: guideTarget_mark, clear: guideTarget_clearMarks, click: guideTarget_click, openTab: guideTarget_openTab,
    findWidget: guideTarget_findWidget,
    openPassport: guideTarget_openPassport, tagBtn: guideTarget_tagBtn, onlyByButton: guideTarget_onlyByButton } // IE 2026 10 13 / ODOO-343435
function tourApi(ctx) {
    const api = { ...TOUR_API, ...(isObj(ctx?.tourApi) ? ctx.tourApi : {}) }
    // demo-webscm 2026 11 02 / ODOO-350612: подпись × выноски — на языке интерфейса (тестовая подмена mark — как есть)
    if (api.mark === guideTarget_mark && typeof ctx?.t === 'function') api.mark = (el, o) => guideTarget_mark(el, { closeLabel: ctx.t('Close hint'), ...o })
    return api
}
// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Приглушаем после прохождения шага или закрытия сообщения. Можно нажать на приглушённый и подсказка
// снова всплывает»): подсказка строки шага — с подписчиком закрытия: пользователь закрыл выноску (× / нажатие по цели) — строка closed (док её приглушает),
// markId — ключ повторного показа (guideTarget_reshow). Сессия переприсваивается — вкладка «Крок» перерисовывается
function tourMarkItem(store, tapi, entry, el, opts) {
    const h = tapi.mark(el, { ...opts, onClose: () => {
        entry.closed = true; entry.shown = false
        try { if (store && store.guideSession && Array.isArray(store.guideSession.tourItems)) store.guideSession = { ...store.guideSession, tourItems: store.guideSession.tourItems.slice() } } catch (e) { /* сессии нет */ }
    } })
    if (h && h.id) entry.markId = h.id
    return h
}
// режим тура сессии: путь с path.tour бэка и включённый fe.guide.tour
export function guidePlay_tour(store, s = null) {
    const ses = s || session(store)
    return !!(ses && ses.path && isObj(ses.path.tour) && guideCases_tourOn(store))
}
export function guidePlay_end(store, ctx = {}) {
    try { tourApi(ctx).clear() } catch (e) { /* подсветок нет */ }   // IE 2026 09 30 / ODOO-343435
    store.guideSession = null
    store.guideRunId = (Number(store.guideRunId) || 0) + 1   // IE 2026 09 28 / ODOO-342342 (ревью З3): идущий показ — отменён
    if (store.guideChips_pending) store.guideChips_pending = null   // чипсы на ещё не открытую страницу — не ставить
    return true
}

function originOf(store, vueObj) {
    const WS = store?.activeWORKSPACE
    const W = vueObj?.WIDGET
    return { workspace: str(WS?.workspace), page: str(WS?.active_page), widgetId: W?.id ?? null, recordId: str(W?.record?.id), segment: str(W?.record?.segment) }
}

// ======================================================================= выполнение плана
function pageShown(store, ws, page) {
    const W = store?.WORKSPACES?.[ws]
    return !!(W && (W.ALL_WIDGETS || []).some(w => w && w.page === page && !w.close))
}
function isActive(store, ws, page) {
    return store?.activeWORKSPACE?.workspace === ws && (!page || store.activeWORKSPACE.active_page === page)
}
async function waitFor(pred, ms, step, sleep, alive = null) {
    let left = ms
    while (left > 0) {
        if (alive && !alive()) return false   // IE 2026 09 28 / ODOO-342342 (ревью З3): показ отменён — не ждать
        let ok = false; try { ok = !!pred() } catch (e) { ok = false } if (ok) return true; await sleep(step); left -= step
    }
    try { return !!pred() } catch (e) { return false }
}

// переход на стол и страницу — как store.clientTest_gotoPage, но router.push (браузерная «Назад» вернёт к кейсу): ждём, пока стол и страница станут
// активными, и даём странице начать открывать виджеты
export async function guidePlay_goto(store, workspace, page, ctx = {}) {
    const sleep = ctx.sleep || defaultSleep
    if (!workspace) return true
    if (isActive(store, workspace, page)) return true
    const pm = store?.process_model_record?.id || ''
    const route = { name: 'db', params: { dbid: store?.user?.database?.dbid }, query: { ...(pm && pm !== store.process_model_current ? { process_model: pm } : {}), workspace, ...(page ? { page } : {}) } }
    // demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: подсказки «иногда зависают и не открываются… может не выполняться шаг переключения»): vue-router 4
    // на переход в тот же адрес (адрес уже ведёт на стол / страницу, а активен другой) не бросает, а отдаёт NavigationFailure — afterEach не зовётся, стол
    // не активируется, и показ ждал все 30 с. Отказ перехода: страница уже построена — активировать её напрямую (как router.afterEach), иначе ждать не
    // дольше navFailWaitMs (активация могла уже идти) и выйти с ошибкой в полосе, а не висеть
    let failed = false
    try {
        const r = store.router.push(route)
        if (r && typeof r.then === 'function') r.then((f) => { if (f) failed = true }, () => { failed = true })
    } catch (e) { return false }
    let failLeft = -1   // мс ожидания после отказа перехода; -1 — отказа не было
    const ok = await waitFor(() => {
        if (isActive(store, workspace, page)) return true
        if (!failed) return false
        if (failLeft < 0) {
            failLeft = ctx.navFailWaitMs ?? 5000
            guideCases_count('navFailed')
            const W = store.WORKSPACES?.[workspace]
            if (page && W?.PAGES?.[page]?.vueObj && typeof store.workspace_activate === 'function') { try { store.workspace_activate(workspace, page) } catch (e) { /* no-op */ } }
            return isActive(store, workspace, page)
        }
        failLeft -= 300
        return false
    }, ctx.navWaitMs ?? 30000, 300, sleep, () => (!ctx.alive || ctx.alive()) && !(failed && failLeft !== -1 && failLeft <= 0))   // IE 2026 09 29 / ODOO-342342 (ревью З3): ✕ полосы — ожидание перехода прерывается
    if (ok && (ctx.settleMs ?? 600)) await sleep(ctx.settleMs ?? 600)
    return ok
}

// шаги плана: plan.steps, пусто — из полей плана (переход, чипсы, цель)
export function guidePlay_steps(plan) {
    if (!isObj(plan)) return []
    if (Array.isArray(plan.steps) && plan.steps.length) return plan.steps.filter(isObj)
    const out = []
    if (plan.workspace) out.push({ action: 'goto_page', workspace: plan.workspace, page: plan.page || '' })
    if (Array.isArray(plan.chips) && plan.chips.length) out.push({ action: 'set_chips', chips: plan.chips })
    const tg = plan.target
    if (isObj(tg) && tg.kind === 'widget' && tg.widget) out.push({ action: 'open_widget', widget: tg.widget, on_page: !!tg.on_page, title: tg.title || '' })
    if (isObj(tg) && tg.kind === 'record' && isObj(tg.record)) out.push({ action: 'open_record', record: tg.record, title: tg.title || '' })
    return out
}

// чипсы якоря при открытии страницы (store.guideChips_pending забирает mainStore.workspace_show_widgets): «мои» строки — копия для «Restore my filters»,
// строки стола — с чипсами якоря; applySelector и открытие виджетов — дальше, как у фильтров ссылки (store._whereFromLink ставит вызывающий). true — применено
export function guidePlay_applyPending(store, W, pend) {
    // IE 2026 09 30 / ODOO-343433: своя функция применения (клик по строке отчёта → страница другого стола, utils/pageGotoChip.js): без «моих» фильтров показа и копии
    // для Restore; pend.apply(W) ставит чипс в память стола и возвращает true, если применила (false — отбор отклонён, страница откроется как есть)
    if (isObj(pend) && typeof pend.apply === 'function') {
        let ok = false
        try { ok = !!pend.apply(W) } catch (e) { ok = false }
        pend.applied = true
        return ok
    }
    const params = W?.record?.doc?.params
    if (!params || !isObj(pend) || !Array.isArray(pend.chips)) return false
    guideBackup_save(store, W.workspace || pend.workspace, { rows: guideChips_userRows(params.WHERE) })
    const res = guideChips_apply(params.WHERE, pend.chips, params.WHERE)
    params.WHERE = res.WHERE
    delete params.calc_selectors_mark
    try { store.update_CHIPS_from_WHERE?.(params) } catch (e) { /* no-op */ }
    pend.applied = true
    guideCases_count('onOpen')
    return true
}
function applyChipsInMemory(store, ws, chips) {
    const W = store?.WORKSPACES?.[ws]
    const params = W?.record?.doc?.params
    if (!params) return null
    guideBackup_save(store, ws, { rows: guideChips_userRows(params.WHERE) })
    const res = guideChips_apply(params.WHERE, chips, params.WHERE)
    params.WHERE = res.WHERE
    delete params.calc_selectors_mark
    try { store.update_CHIPS_from_WHERE?.(params) } catch (e) { /* no-op */ }
    store.workspace_applySelector(ws, W.active_page)
    guideCases_count('inMemory')
    return res
}

// открыть цель: виджет страницы (on_page) — дождаться, пока страница сама его откроет, и активировать; иначе открыть по id (без «client test»)
async function openWidget(store, st, ctx) {
    const sleep = ctx.sleep || defaultSleep
    const WS = store.activeWORKSPACE
    const find = () => (store.activeWORKSPACE?.ALL_WIDGETS || []).find(w => w && !w.close && w.page === store.activeWORKSPACE.active_page
        && (w.widget === st.widget || w.record?.id === st.widget))
    if (st.on_page) await waitFor(() => !!find(), ctx.onPageWaitMs ?? 15000, 300, sleep, ctx.alive)
    if (ctx.alive && !ctx.alive()) return { opened: false, activated: false, cancelled: true }   // IE 2026 09 28 / ODOO-342342 (ревью З3)
    const W = find()
    if (W) {
        if (W._softClosed) { try { store._widget_restoreSoftClosed(W) } catch (e) { /* no-op */ } }
        try { store.widget_activate(W, 'guide_play', true, true) } catch (e) { /* no-op */ }
        return { opened: false, activated: true }
    }
    store.executeStoreMethod({}, { command: 'widget_open', widget: st.widget, workspace: WS?.workspace, page: WS?.active_page, _activate: true })
    guideCases_count('targetsOpened')
    return { opened: true, activated: false }
}

// План ответа play_plan → переход, чипсы, цель. ctx: vueObj (форма кейса — «Back to the case»), t, confirm(text) → bool | Promise<bool>,
// notify(text, status), sleep(ms). Возвращает { ok, status, reason }
// demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «Чтобы продемонстрировать основные меню, не обязательно переключаться в какой-то предопределенный
// рабочий стол или страницу. Нужен механизм если его нет пропустить шаги и показать элементы на текущем экране»): тема показывается ЗДЕСЬ — без перехода на
// стол / страницу якоря (goto_page и чипсы страницы снимаются), если: бэк пометил план here (строка темы here: true — каркас: шапка, меню пользователя, ПМ,
// база), либо (auto — путь навигатора) у темы есть цели, ВСЕ они элементы каркаса (kind ui) и уже ВИДНЫ на текущем экране, и ничто в шагах не привязано к
// другой странице (виджет, ячейка, вкладка, чипсы страницы, проверка «спробую сам» на другом столе / странице). Тема без целей (о самой странице) — как прежде
const HERE_FREE = ['goto_page', 'tour_note', 'cta', 'presenter_only', 'wait']
const HERE_FREE_CHECKS = ['dom', 'alt_tip', 'question_sent']   // ODOO-350612: проверки «спробую сам», которым страница темы не нужна
// demo-webscm 2026 11 02 / ODOO-350612 (devap -136, тема 14 01W_00l «Інші команди» grid.commandPanel.overflow: с page-approval показ остался на месте и подсветил
// панель команд ЧУЖОГО виджета): авто-правило — только для целей каркаса (шапка, меню пользователя, панель страниц, док навигатора); цели виджетов (grid.*,
// chips.*, chart.*, …) видны и на других страницах, но тема — про виджет СВОЕЙ страницы: переход как прежде, если бэк явно не пометил тему here: true.
// Список разрешающий: незнакомый ключ — переход (поведение до ODOO-350612)
export const HERE_SHELL_PREFIXES = ['topbar.', 'userMenu.', 'menuPanel.', 'navigator.']
export function guidePlay_shellTarget(target) {
    const help = isObj(target) && str(target.kind) === 'ui' ? str(target.help) : ''
    return !!help && HERE_SHELL_PREFIXES.some(p => help.startsWith(p))
}
function uiVisible(el) {
    if (!el) return false
    if (el.guideGroup) return typeof el.visibleCount === 'function' ? el.visibleCount() > 0 : true
    if ('offsetWidth' in el || 'offsetHeight' in el) return el.offsetWidth > 0 || el.offsetHeight > 0
    return true
}
export function guidePlay_here(plan, steps, cur = {}, opts = {}) {
    if (!isObj(plan)) return false
    if (plan.here === true) return true
    if (!opts.auto || !Array.isArray(steps) || !steps.some(s => isObj(s) && s.action === 'goto_page')) return false
    const uiEl = typeof opts.uiEl === 'function' ? opts.uiEl : guideTarget_uiEl
    let targets = 0
    for (const st of steps) {
        if (!isObj(st)) continue
        const act = str(st.action)
        if (HERE_FREE.includes(act)) continue
        if (act !== 'highlight' && act !== 'wait_for') return false   // set_chips, open_widget, open_record, open_tab, open_cell_passport — страница нужна
        // demo-webscm 2026 11 03 / ODOO-350612 (dm после импорта: тема 2 «панель сторінок» осталась на текущей странице, хотя её «спробую сам» — «откройте
        // страницу «Список розрахунку»» стола Distribution): авто-«здесь» только при проверке, не привязанной к странице / столу (HERE_FREE_CHECKS: dom,
        // alt_tip, question_sent) и без workspace / page / widget в ней; page, workspace, widget_open, popout, tab, chip_added и незнакомые — переход
        if (act === 'wait_for' && isObj(st.check)) {
            const c = st.check
            if (!HERE_FREE_CHECKS.includes(str(c.kind)) || c.workspace || c.page || c.widget) return false
        }
        if (!isObj(st.target)) { if (act === 'highlight') return false; continue }
        if (!guidePlay_shellTarget(st.target)) return false   // ODOO-350612 (devap -136): цель виджета / не каркаса — нужна страница темы
        let el = null
        try { el = uiEl(opts.doc, st.target) } catch (e) { el = null }
        if (!uiVisible(el)) return false
        targets++
    }
    return targets > 0
}
// служебный префикс уведомления бэка (attrs.TERMINAL: «!WARNING » / «!!ERROR » / «!!!CRITICAL » + метка времени) — не для глаз пользователя (ODOO-350612:
// док показывал «!WARNING Недоступно для вашої ролі»)
const NOTE_PREFIX_RE = /^\s*!{1,3}(?:WARNING|ERROR|CRITICAL)\s+(?:\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?\s+)?/
export function guidePlay_cleanMsg(text) { return str(text).replace(NOTE_PREFIX_RE, '') }

export async function guidePlay_run(store, answer, ctx = {}) {
    const t = typeof ctx.t === 'function' ? ctx.t : identityT
    const notify = typeof ctx.notify === 'function' ? ctx.notify : () => {}
    const sleep = ctx.sleep || defaultSleep
    const t0 = ctx.t0 ?? guideCases_now()
    // IE 2026 09 28 / ODOO-342342 (ревью З3): номер показа — от guidePlay_start; вызов напрямую заводит свой
    const run = ctx.run != null ? ctx.run : runNew(store)
    const alive = () => runAlive(store, run)
    ctx = { ...ctx, alive }
    if (!alive()) return runCancelled()
    const tapi = tourApi(ctx)   // IE 2026 09 30 / ODOO-343435: подсветки прежнего шага — снять
    try { tapi.clear() } catch (e) { /* no-op */ }
    // IE 2026 09 28 / ODOO-342342 (ревью З5): нет ответа (HTTP-ошибка, обрыв, битый JSON, таймаут) — причина в полосе (жёлтая, status error), без своего
    // тоста: об HTTP-ошибке стор уже сказал («Backend error»), второй тост о том же не нужен
    if (!isObj(answer)) {
        guideCases_count('playErrors')
        const m = t('No answer from the server — the demo was not opened')
        setSession(store, { busy: false, status: 'error', message: m, error: m })
        return { ok: false, status: 'error' }
    }
    const status = str(answer.status || (answer.plan ? 'ok' : 'error'))
    const msg = guidePlay_cleanMsg(answer.notification?.text || answer.error || answer.message)   // ODOO-350612: без «!WARNING »
    const shown = !!str(answer.notification?.text)   // уведомление ответа store уже показал (TERMINAL → show_notification) — второй раз не показываем
    // сессия: кейс, путь, якоря — из ответа (путь без шагов в ответе — прежний)
    const prev = session(store)
    const path = isObj(answer.path) ? { id: str(answer.path.id), title: str(answer.path.title), step: Number(answer.path.step) || null, total: Number(answer.path.total) || 0,
        steps: Array.isArray(answer.path.steps) ? guidePath_fromPlan(answer.path) : (prev?.path?.id === str(answer.path.id) ? prev.path.steps : []),
        // IE 2026 09 30 / ODOO-343435: режим тура пути (бэк: path.tour {marks, metrics, skippable})
        tour: isObj(answer.path.tour) ? { ...answer.path.tour } : (prev?.path?.id === str(answer.path.id) ? (prev.path.tour || null) : null) } : (ctx.keepPath && prev?.path ? prev.path : null)
    if (path && ctx.step && !path.step) path.step = Number(ctx.step)
    // якоря и кейс прежней сессии — только при шаге той же сессии (keepPath: Next / Back пути или видов кейса); новый показ их не наследует
    const anchors = Array.isArray(answer.anchors) ? answer.anchors.filter(isObj) : (ctx.keepPath ? (prev?.anchors || []) : [])
    const base = {
        seq: (prev?.seq || 0) + (ctx.keepPath ? 0 : 1), busy: false, error: '', status, message: '',
        case: isObj(answer.case) ? { id: str(answer.case.id), title: str(answer.case.title), kind: str(answer.case.kind), status: str(answer.case.status), status_title: str(answer.case.status_title) } : (ctx.keepPath ? (prev?.case || null) : null),
        path, anchors, anchor: isObj(answer.anchor) ? answer.anchor : null,
        rights: isObj(answer.rights) ? answer.rights : (prev?.rights || null),
        origin: ctx.origin || prev?.origin || null,
        presenter: [], target: null, startedAt: prev?.startedAt || Date.now(),
        tourItems: [],   // IE 2026 09 30 / ODOO-343435: заметки / подсказки без цели / кнопки cta шага тура (полоса)
    }
    if (status === 'not_available') {
        guideCases_count('denied')
        if (!shown) notify(msg || t('Not available for your role'), 'warning')
        setSession(store, { ...base, message: msg || t('Not available for your role') })
        return { ok: false, status }
    }
    if (status === 'soon') {
        guideCases_count('soon')
        setSession(store, { ...base, message: msg || t('Coming soon: this use case is not in the demo yet') })
        return { ok: false, status }
    }
    if (status === 'no_anchor') {
        // IE 2026 09 28 / ODOO-342342 (контракт v1.1: у кейсов Demo якорей пока нет — ie-demo7 вписывает их по YAML): не ошибка — понятная строка в полосе, без тоста
        guideCases_count('noAnchor')
        setSession(store, { ...base, message: msg || t('No demo view is linked to this use case yet: there is nothing to open in the demo') })
        return { ok: false, status }
    }
    if (status !== 'ok' || !isObj(answer.plan)) {
        guideCases_count('playErrors')
        if (!shown) notify(msg || t('The demo could not be opened'), 'error')
        setSession(store, { ...base, status: 'error', message: msg || t('The demo could not be opened'), error: msg || 'error' })
        return { ok: false, status: 'error' }
    }
    const plan = answer.plan
    setSession(store, { ...base, busy: true, target: { workspace: str(plan.workspace), workspace_title: str(plan.workspace_title), page: str(plan.page), page_title: str(plan.page_title),
        kind: str(plan.target?.kind), title: str(plan.target?.title) } })
    // ПМ якоря не текущая — спросить
    if (plan.switch_process_model && plan.process_model && store.process_model_record?.id !== plan.process_model) {
        let yes = false
        // IE 2026 09 28 / ODOO-342342 (ревью З6): в вопросе — название модели (process_model_title бэка), иначе id
        const pmTitle = str(plan.process_model_title).trim() || str(plan.process_model)
        try { yes = await (ctx.confirm ? ctx.confirm(t('This demo view was made on another process model: {pm}. Switch to it?', { pm: pmTitle }), { pm: pmTitle }) : false) } catch (e) { yes = false }
        if (!alive()) return runCancelled()   // IE 2026 09 28 / ODOO-342342 (ревью З3)
        if (yes) { guideCases_count('pmSwitched'); try { await store.clientTest_switchPm(plan.process_model) } catch (e) { /* остаёмся */ } } else guideCases_count('pmKept')
        if (!alive()) return runCancelled()
    }
    let steps = guidePlay_steps(plan)
    const onOpen = guideCases_flag(store, FLAG_CHIPS_OPEN)
    const presenter = []
    const tourItems = []   // IE 2026 09 30 / ODOO-343435
    const tourOn = guideCases_tourOn(store)
    let curWs = store.activeWORKSPACE?.workspace || '', curPage = store.activeWORKSPACE?.active_page || ''
    // ODOO-350612: тема на текущем экране — до маршрута (иначе «1. откройте список столов… 2. на панели сторінок…» всё равно рисуются)
    const navPath = !!(path && isObj(path.tour) && path.tour.navigator)
    const here = guidePlay_here(plan, steps, { workspace: curWs, page: curPage }, { auto: tourOn && navPath, doc: ctx.doc || globalThis.document, uiEl: tourApi(ctx).uiEl })
    if (here) {
        steps = steps.filter(s => s.action !== 'goto_page' && s.action !== 'set_chips')
        guideCases_count('playedHere')
        const tg = store.guideSession?.target   // стол / страница плана не открываются — полоса их не называет
        if (tg) store.guideSession = { ...store.guideSession, target: { ...tg, workspace: '', workspace_title: '', page: '', page_title: '' } }
    }
    // demo-webscm 2026 11 02 / ODOO-350612 (слово владельца: «цифру в кружочке и короткое примечание 1. Кликаем… 2. выбираем…»): маршрут показа — только у пути
    // навигатора (path.tour.navigator; туры кейсов Игоря не меняются): клики, которые понадобились бы пользователю (стол → страница → виджет → цель), выводятся
    // из плана (utils/guideRoute.js), каждый получает номер по порядку исполнения: кружок у элемента (guideTarget_mark badge) + строка «n. …» в tourItems
    // (kind route) для вкладки «Крок»; подсветки действий тура продолжают нумерацию. Элемента нет на экране — строка остаётся, кружка нет
    const routeOn = tourOn && !!((path && isObj(path.tour) && path.tour.navigator) || ctx.route)
    const route = routeOn ? { n: 0, items: guideRoute_items(plan, steps, { workspace: curWs, page: curPage }, t), doc: ctx.doc || globalThis.document, win: ctx.win, handles: [] } : null
    // demo-webscm 2026 11 03 / ODOO-350612 (devap -139, тема 14 → 01W_00l: выноска «1. Відкрийте список робочих областей…» прежнего экрана висела и после перехода):
    // переход на другой стол / страницу снимает выноски маршрута, поставленные ДО него; строки шагов в доке остаются (remove, не close — без приглушения)
    const routeDropPrev = () => { if (!route) return; for (const h of route.handles.splice(0)) { try { h.remove() } catch (e) { /* уже снята */ } } }
    ctx = { ...ctx, routeSeq: route }
    const live = () => { try { if (store.guideSession) store.guideSession = { ...store.guideSession, tourItems: tourItems.slice() } } catch (e) { /* сессии нет */ } }
    const routeMark = async (kind, match) => {   // следующая запись маршрута этого вида (match — проверка её полей) → номер, кружок, строка
        if (!route) return
        const item = route.items.find(x => !x.done && x.kind === kind && (!match || match(x)))
        if (!item) return
        item.done = true
        const n = ++route.n
        let el = null
        try { el = guideRoute_el(route.doc, store, item, tapi.findWidget) } catch (e) { el = null }
        const entry = { kind: 'route', n, text: item.text, marked: false }
        if (el) { try { const h = tourMarkItem(store, tapi, entry, el, { text: item.text, badge: n, placement: kind === 'workspace' ? 'bottom' : 'right', pulse: true, doc: ctx.doc, win: ctx.win }); entry.marked = !!h; if (h) route.handles.push(h) } catch (e) { entry.marked = false } }
        const marked = entry.marked
        tourItems.push(entry)
        live()
        if (marked) guideCases_count('routeMarks')
        const ms = ctx.routeStepMs ?? 700   // показ «по очереди»: кружок виден до следующего шага
        if (ms) await sleep(ms)
    }
    try {
        for (let i = 0; i < steps.length; i++) {
            const st = steps[i]
            const act = str(st.action)
            if (act === 'goto_page') {
                const ws = str(st.workspace || plan.workspace), page = str(st.page || plan.page)
                if (!ws) continue
                // чипсы следующего шага — при открытии страницы, если она ещё не открывалась (одна загрузка), иначе — после перехода в памяти
                const nxt = steps[i + 1]
                const chips = (isObj(nxt) && nxt.action === 'set_chips') ? (nxt.chips || plan.chips || []) : null
                let pend = null
                if (chips && chips.length && onOpen && !pageShown(store, ws, page) && !isActive(store, ws, page)) {
                    pend = { workspace: ws, page, chips }
                    store.guideChips_pending = pend
                }
                if (ws !== curWs) await routeMark('workspace', x => x.workspace === ws)   // ODOO-350612: «1. откройте список столов…» — кружок на кнопке шапки до перехода
                if (!alive()) return runCancelled()
                const ok = await guidePlay_goto(store, ws, page, ctx)
                if (pend && store.guideChips_pending === pend) store.guideChips_pending = null   // не забрали (страница уже строилась / переход не вышел) — не оставлять
                if (!alive()) return runCancelled()   // IE 2026 09 28 / ODOO-342342 (ревью З3)
                if (!ok) throw new Error(t('Navigation to the demo page timed out'))
                if (ws !== curWs || page !== curPage) routeDropPrev()   // ODOO-350612: выноски прежнего экрана — долой
                if (page && page !== curPage) await routeMark('page', x => x.page === page)   // ODOO-350612: «2. на панели сторінок натисніть…» — кружок на кнопке страницы после перехода
                if (!alive()) return runCancelled()
                curWs = ws; curPage = page
                if (pend) {
                    if (!pend.applied) applyChipsInMemory(store, ws, chips)
                    i++   // следующий шаг set_chips выполнен здесь
                }
            } else if (act === 'set_chips') {
                const chips = st.chips || plan.chips || []
                const ws = curWs || plan.workspace
                // виджеты страницы ещё открываются — дождаться (иначе ответ открытия принесёт данные с прежними чипсами поверх новых)
                await waitFor(() => !(store.WORKSPACES?.[ws]?.ALL_WIDGETS || []).some(w => w && w.page === curPage && !w.close && w._openRequest && w._openRequest.readyState !== 4), ctx.openWaitMs ?? 20000, 400, sleep, alive)
                if (!alive()) return runCancelled()   // IE 2026 09 28 / ODOO-342342 (ревью З3)
                if (!applyChipsInMemory(store, ws, chips)) throw new Error(t('The demo filters could not be set: the workspace is not open'))
            } else if (act === 'open_widget') {
                if (!st.widget) continue
                await openWidget(store, st, ctx)
                if (!alive()) return runCancelled()   // IE 2026 09 28 / ODOO-342342 (ревью З3)
                await routeMark('widget', x => x.widget === str(st.widget))   // ODOO-350612: «3. відкрийте віджет…» — кружок на виджете
                if (!alive()) return runCancelled()
            } else if (act === 'open_record') {
                const r = isObj(st.record) ? st.record : null
                if (!r || !r.id) continue
                store.executeStoreMethod({}, { command: 'widget_open', widget: 'widget-record', open_in_children_widget: true, _activate: true,
                    item: { id: str(r.id), segment: r.segment ? str(r.segment) : undefined, version: str(r.version || '') || undefined, title: str(st.title || plan.target?.title || '') || undefined } })   // заголовок формы до ответа — название цели, а не id
                guideCases_count('targetsOpened')
            } else if (act === 'wait') {
                const s = Math.min(10, Math.max(0, Number(st.seconds ?? st.value) || 0))
                if (s) await sleep(s * 1000)
                if (!alive()) return runCancelled()   // IE 2026 09 28 / ODOO-342342 (ревью З3)
            } else if (act === 'presenter_only') {
                presenter.push(str(st.text || st.title))
                guideCases_count('presenterOnly')
            } else if (tourOn && TOUR_ACTIONS.includes(act)) {
                // IE 2026 09 30 / ODOO-343435: действие тура — ошибка цели не прерывает показ (текст шага остаётся в полосе)
                await runTourStep(store, st, { ...ctx, t, sleep }, tapi, tourItems)
                if (!alive()) return runCancelled()
            }
        }
    } catch (e) {
        if (!alive()) return runCancelled()   // IE 2026 09 28 / ODOO-342342 (ревью З3)
        guideCases_count('playErrors')
        const m = str(e && e.message || e)
        notify(m, 'error')
        setSession(store, { busy: false, error: m, presenter, tourItems })   // IE 2026 09 30 / ODOO-343435: + tourItems
        return { ok: false, status: 'error', reason: m }
    }
    if (!alive()) return runCancelled()
    guideCases_count('play', guideCases_now() - t0)
    setSession(store, { busy: false, presenter, tourItems })   // IE 2026 09 30 / ODOO-343435: + tourItems
    return { ok: true, status: 'ok' }
}

// ======================================================================= IE 2026 09 30 / ODOO-343435: шаг тура
export const TOUR_ACTIONS = ['highlight', 'open_cell_passport', 'open_tab', 'tour_note', 'cta', 'wait_for']   // wait_for — demo-webscm 2026 11 02 / ODOO-350612 (навигатор: «спробую сам»)
async function runTourStep(store, st, ctx, tapi, items) {
    const act = str(st.action)
    const t = ctx.t
    const text = str(st.text)
    const image = str(st.image)
    const route = ctx.routeSeq || null   // ODOO-350612: маршрут навигатора — подсветка цели продолжает нумерацию кликов (кружок + «n.» в строке)
    const badge = () => (route ? ++route.n : undefined)
    if (act === 'tour_note') {
        if (text || image) { items.push({ kind: 'note', text, image }); guideCases_count('tourNotes') }
        return
    }
    if (act === 'cta') {
        const c = { kind: 'cta', label: str(st.label), text, url: str(st.url), page: str(st.page), workspace: str(st.workspace), cta: str(st.kind) }
        if (c.label && (/^https:\/\//i.test(c.url) || c.page)) { items.push(c); guideCases_count('tourCta') }
        return
    }
    const hint = () => { if (text || image) items.push({ kind: 'hint', text, image }); guideCases_count('tourMissed') }
    if (act === 'wait_for') {   // demo-webscm 2026 11 02 / ODOO-350612: «спробую сам» — подсветить цель (если есть) и ждать, пока предикат по стору станет истинным
        const check = isObj(st.check) ? st.check : null   // (utils/guideChecks.js) или пользователь нажмёт «Пропустити» (store.navigator.skipEpoch); таймаут — секунды бэка
        const snap = guideChecks_begin(store, check)
        const skip0 = Number(store?.navigator?.skipEpoch) || 0
        let h = null
        const item = { kind: 'check', text, image, n: undefined, hint: str(st.hint), ok: false, skipped: false, pending: true, timeout: Number(st.timeout) || 120, startedAt: Date.now() }
        if (isObj(st.target)) {
            let res = null
            try { res = await tapi.resolve(store, st.target, ctx) } catch (e) { res = null }
            if (!ctx.alive()) return
            if (res && res.el) { item.n = badge(); h = tourMarkItem(store, tapi, item, res.el, { text, image, badge: item.n, placement: str(st.placement) || 'right', pulse: st.pulse !== false, doc: ctx.doc, win: ctx.win }) }
        }
        item.startedAt = Date.now()
        items.push(item)
        const live = () => { try { if (store.guideSession) store.guideSession = { ...store.guideSession, tourItems: items.slice() } } catch (e) { /* сессии нет */ } }
        live()
        const skipped = () => (Number(store?.navigator?.skipEpoch) || 0) > skip0
        const ok = check ? await waitFor(() => skipped() || guideChecks_eval(store, check, snap, ctx.doc), item.timeout * 1000, 500, ctx.sleep, ctx.alive) : false
        if (!ctx.alive()) return
        item.pending = false
        item.skipped = ok && skipped() && !guideChecks_eval(store, check, snap, ctx.doc)
        item.ok = ok && !item.skipped
        if (item.ok) { try { h && h.remove && h.remove() } catch (e) { /* подсветки нет */ } guideCases_count('tourChecksOk') }
        else guideCases_count(item.skipped ? 'tourChecksSkipped' : 'tourChecksTimeout')
        live()
        return
    }
    if (act === 'open_tab') {
        const W = tapi.findWidget(store, st.target)
        const ok = !!(W && tapi.openTab(W, st.target?.tab))
        if (ok) guideCases_count('tourTabs')
        if (route && str(st.target?.tab)) {   // ODOO-350612: «n. відкрийте вкладку…» — кружок на виджете вкладки
            const n = ++route.n, tx = t('Open the «{tab}» tab', { tab: str(st.target?.tab) })
            const el = W?.vueObj?.$el
            const entry = { kind: 'route', n, text: tx, marked: false }
            if (el && el.nodeType === 1) { try { entry.marked = !!tourMarkItem(store, tapi, entry, el, { text: tx, badge: n, placement: 'right', pulse: true, doc: ctx.doc, win: ctx.win }) } catch (e) { entry.marked = false } }
            items.push(entry)
        }
        if (text || image) items.push({ kind: 'hint', text, image })
        if (!ok) guideCases_count('tourMissed')
        return
    }
    let res = null
    try { res = await tapi.resolve(store, st.target, ctx) } catch (e) { res = null }
    if (!ctx.alive()) return
    if (!res || !res.el) { hint(); return }
    if (res.fallback) guideCases_count('tourFallback')
    if (act === 'open_cell_passport' && str(st.mode) === 'auto' && !res.fallback) {
        if (tapi.click(res.el)) guideCases_count('tourClicks')
        if (tapi.openPassport?.(res)) guideCases_count('tourPassports')   // IE 2026 10 13 / ODOO-343435: клик только выделяет ячейку — паспорт открывается путём 🏷
        if (text) items.push({ kind: 'hint', text, image })
        return
    }
    const onlyBtn = act === 'open_cell_passport' && !!(tapi.onlyByButton ? tapi.onlyByButton(res) : res?.W?.vueObj?.cellForm_onlyByButton?.())   // IE 2026 10 13 / ODOO-343435
    const tip = act === 'open_cell_passport' ? (text || (onlyBtn ? t('Click the highlighted cell, then press F4 or the tag button to open its passport') : t('Click the highlighted cell to open its passport'))) : text   // IE 2026 10 13 / ODOO-343435
    const n = badge()
    const entry = { kind: 'route', n, text: tip, image, marked: true }
    const h = tourMarkItem(store, tapi, entry, res.el, { text: tip, image, badge: n, placement: str(st.placement) || 'right', pulse: st.pulse !== false, doc: ctx.doc, win: ctx.win })
    if (h) { guideCases_count('tourMarks'); if (route && (text || image)) items.push(entry) }   // ODOO-350612: цель — последний номер маршрута, строка во вкладке «Крок»
    else hint()
    if (h && onlyBtn) {   // IE 2026 10 13 / ODOO-343435: кнопка 🏷 грида — вторая подсветка (первая остаётся)
        const btn = tapi.tagBtn?.(res.W)   // IE 2026 10 13 / ODOO-343435
        if (btn && tapi.mark(btn, { text: t('Cell form'), placement: 'bottom', pulse: true, doc: ctx.doc, win: ctx.win })) guideCases_count('tourMarks')   // IE 2026 10 13 / ODOO-343435
    }   // IE 2026 10 13 / ODOO-343435
}

// «Open in demo» / «Start path» / шаг пути: play_plan → guidePlay_run. params: {id?, step?, anchor?}; ctx: vueObj формы кейса, t, confirm, notify, sleep, send
export async function guidePlay_start(store, params, ctx = {}) {
    if (!guideCases_on(store)) return { ok: false, status: 'off' }
    const t0 = guideCases_now()
    const origin = ctx.keepPath ? (session(store)?.origin || originOf(store, ctx.vueObj)) : originOf(store, ctx.vueObj)
    const run = runNew(store)   // IE 2026 09 28 / ODOO-342342 (ревью З3): прежний показ (если шёл) — недействителен
    setSession(store, { busy: true, error: '', ...(ctx.keepPath ? {} : { origin }) })
    const send = ctx.send || ((m, p) => guideApi_send(store, m, p, { recordId: params?.id }))
    // demo-webscm 2026 11 02 / ODOO-350612 (подсказки «иногда зависают и не открываются»): исключение вне try показа (разбор ответа, маршрут, переход ПМ)
    // оставляло busy: true — «Покажи» дока неактивна до перезагрузки. Любой выход текущего показа отпускает busy; отменённый показ сессию не трогает
    try {
        const answer = await send('play_plan', params || {})
        guideCases_addMs('planMs', guideCases_now() - t0)
        if (!runAlive(store, run)) return runCancelled()   // ✕ полосы, пока ждали план, — ни перехода, ни полосы
        return await guidePlay_run(store, answer, { ...ctx, origin, t0, step: params?.step, run })
    } catch (e) {
        if (!runAlive(store, run)) return runCancelled()
        guideCases_count('playErrors')
        const m = str(e && e.message || e) || 'error'
        setSession(store, { busy: false, status: 'error', error: m, message: m })
        return { ok: false, status: 'error', reason: m }
    } finally {
        if (runAlive(store, run) && session(store)?.busy) setSession(store, { busy: false })
    }
}

// IE 2026 09 28 / ODOO-342342 (ревью З8): показ уже открывается (полоса «Opening the demo…») — второй запуск (двойной клик по кнопке бэка, команда
// guide_play) не начинается; отменить идущий — ✕ полосы
export function guidePlay_busy(store) { return !!session(store)?.busy }

// шаг пути n (номер бэка): текущий шаг сессии, место в пути (set_position — ctx.setPos), план шага; откуда пришли («Back to the case») — прежнее
export async function guidePlay_jump(store, n, ctx = {}) {
    const s = session(store)
    const step = Number(n)
    if (!s || !s.path || !s.path.id || !(step > 0)) return { ok: false, status: 'none' }
    guideCases_count('pathSteps')
    setSession(store, { path: { ...s.path, step } })
    // IE 2026 09 30 / ODOO-343435: режим тура (marks = false) — место в пути не пишется (общая учётка гостей: «Continue: step N» друг друга)
    const noMarks = guidePlay_tour(store, s) && s.path.tour.marks !== true
    if (noMarks) guideCases_count('tourPosSkipped')
    else if (typeof ctx.setPos === 'function') { try { ctx.setPos(s.path.id, step) } catch (e) { /* позиция best effort */ } }
    return guidePlay_start(store, { id: s.path.id, step }, { ...ctx, keepPath: true })
}

// Next / Back пути (шаги path.steps) или видов кейса (якоря anchors); dir: +1 / -1. Позиция пути — set_position (ctx.setPos)
export async function guidePlay_step(store, dir, ctx = {}) {
    const s = session(store)
    if (!s) return { ok: false, status: 'none' }
    if (s.path && s.path.id && s.path.steps && s.path.steps.length) {
        const i = guidePath_index(s.path.steps, s.path.step)
        const j = dir > 0 ? guidePath_next(s.path.steps, i < 0 ? -1 : i) : guidePath_prev(s.path.steps, i < 0 ? 0 : i)
        if (j < 0 || j === i) return { ok: false, status: 'edge' }
        return guidePlay_jump(store, s.path.steps[j].n, ctx)
    }
    guideCases_count('pathSteps')
    const list = s.anchors || []
    if (list.length > 1 && s.case && s.case.id) {
        const cur = list.findIndex(a => str(a.id) === str(s.anchor?.id))
        const j = Math.max(0, Math.min(list.length - 1, (cur < 0 ? 0 : cur) + (dir > 0 ? 1 : -1)))
        if (j === cur) return { ok: false, status: 'edge' }
        return guidePlay_start(store, { id: s.case.id, anchor: str(list[j].id) }, { ...ctx, keepPath: true })
    }
    return { ok: false, status: 'edge' }
}

// «Back to the case»: стол и страница, откуда пришли, и форма кейса (открыта — активировать, закрыта — открыть запись)
export async function guidePlay_back(store, ctx = {}) {
    const s = session(store)
    const o = s?.origin
    if (!o || !o.workspace) return false
    guideCases_count('backToCase')
    const ok = await guidePlay_goto(store, o.workspace, o.page, ctx)
    if (!ok) return false
    const all = store.WORKSPACES?.[o.workspace]?.ALL_WIDGETS || []
    const W = o.widgetId != null ? all.find(w => w && w.id === o.widgetId && !w.close) : null
    if (W) {
        if (W._softClosed) { try { store._widget_restoreSoftClosed(W) } catch (e) { /* no-op */ } }
        try { store.widget_activate(W, 'guide_back', true, true) } catch (e) { /* no-op */ }
        return true
    }
    const id = str(s.path?.id || s.case?.id || o.recordId)
    if (id) store.executeStoreMethod({}, { command: 'widget_open', widget: 'widget-record', open_in_children_widget: true, _activate: true, item: { id, segment: UC_SEGMENT } })
    return true
}

// текущий шаг сессии: кейс шага пути (id для «пройдено») или кейс показа
export function guidePlay_current(s) {
    if (!s) return null
    if (s.path && s.path.steps && s.path.steps.length) {
        const i = guidePath_index(s.path.steps, s.path.step)
        if (i >= 0) return { ...s.path.steps[i], index: i, total: s.path.steps.length }
    }
    return s.case ? { id: s.case.id, title: s.case.title, kind: s.case.kind, status: s.case.status, status_title: s.case.status_title, index: -1, total: 0 } : null
}

// IE 2026 09 30 / ODOO-343435: кнопка cta полосы тура — страница демо (переход, как шаг goto_page) или внешняя https-ссылка в новой вкладке (noopener)
export async function guidePlay_cta(store, item, ctx = {}) {
    if (!isObj(item)) return false
    guideCases_count('tourCtaClicks')
    const url = str(item.url)
    if (url) {
        if (!/^https:\/\//i.test(url)) return false
        const win = ctx.win || globalThis.window
        try { win.open(url, '_blank', 'noopener') } catch (e) { return false }
        return true
    }
    if (!item.page) return false
    const ws = str(item.workspace) || str(store?.activeWORKSPACE?.workspace)
    return guidePlay_goto(store, ws, str(item.page), ctx)
}

export default { guideApi_send, guideApi_vueObj, guideChips_apply, guideChips_userRows, guideChips_isService, guideBackup_key, guideBackup_list, guideBackup_get, guideBackup_save, guideBackup_restore, guidePlay_chipsKeepHeld, guidePlay_applyPending, guidePlay_goto, guidePlay_run, guidePlay_start, guidePlay_busy, guidePlay_jump, guidePlay_step, guidePlay_back, guidePlay_end, guidePlay_steps, guidePlay_current, guidePlay_tour, guidePlay_cta, guidePlay_here, guidePlay_shellTarget, guidePlay_cleanMsg }   // ODOO-350612: + guidePlay_here, guidePlay_cleanMsg; IE 2026 09 29 / ODOO-342342: + guidePlay_chipsKeepHeld (ревью З4), guidePlay_busy (ревью З8); IE 2026 09 30 / ODOO-343435: + guidePlay_tour, guidePlay_cta
